import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/one'));
// Users
const UserAccountPage = lazy(() => import('src/pages/dashboard/account'));

// Products
const Products = lazy(() => import('src/pages/dashboard/products'));
const ProductsCreateView = lazy(() => import('src/pages/dashboard/productsCreatePage'));

// Combos
const CombosCreateView = lazy(() => import('src/sections/combos/view/combos-create-view'));
const CombosEditView = lazy(() => import('src/sections/combos/view/combos-edit-view'));
const ProductEditView = lazy(()=> import('src/pages/dashboard/productsEditPage'))
// History
const History = lazy(() => import('src/pages/dashboard/history'));

// Configuracion Fel
const ConfiguracionFel = lazy(() => import('src/pages/dashboard/settingsFel'));
const ConfiguracionFelCreate = lazy(() => import('src/pages/dashboard/settingsFelCreatePage'));

// Dashboards
const DashboardVentas = lazy(() => import('src/pages/dashboard/dashboardVentas'));
const DashboardComparisons = lazy(() => import('src/pages/dashboard/dashboardComparisons'));

// Reportes
const ReporteVentas = lazy(() => import('src/pages/dashboard/reporteVentas'));

// History
const Kitchen = lazy(() => import('src/pages/dashboard/kitchen'));

// Clients
const Clients = lazy(() => import('src/pages/dashboard/clients'));

// Traslados
const Traslados = lazy(() => import('src/pages/dashboard/traslados'));
const TrasladosCreatePage = lazy(() => import('src/pages/dashboard/trasladosCreatePage'));
const TrasladosEditPage = lazy(() => import('src/pages/dashboard/trasladosEditPage'));

// Compras
const Compras = lazy(() => import('src/pages/dashboard/compras'));
const ComprasCreatePage = lazy(() => import('src/pages/dashboard/comprasCreatePage'));
const Proveedores = lazy(() => import('src/pages/dashboard/proveedores'));

// Cajas
const CashBox = lazy(() => import('src/pages/dashboard/cashBox'));

// Cajeros
const Cashiers = lazy(() => import('src/pages/dashboard/cashiers'));
const CashiersCreateView = lazy(() => import('src/pages/dashboard/cashiersCreatePage'));

// Categorias
const Categories = lazy(() => import('src/pages/dashboard/categories'));
const CategoriesCreateView = lazy(() => import('src/pages/dashboard/categoriesCreatePage'));

// Inventario
const PronosticoInventario = lazy(() => import('src/pages/dashboard/pronosticoInventario'));
const PronosticoProductos = lazy(() => import('src/pages/dashboard/pronosticoProductos'));

// Atributos
const Atributos = lazy(() => import('src/pages/dashboard/attributes'))
const AtributosCreateView = lazy(() => import('src/pages/dashboard/attributesCreatePage'))

// Impresoras
const Impresoras = lazy(() => import('src/pages/dashboard/printers'))
const ImpresorasCreateView = lazy(() => import('src/pages/dashboard/printersCreatePage'))
// ----------------------------------------------------------------------

// Care
const Pacientes = lazy(()=> import('src/pages/dashboard/patients'))
const Citas = lazy(()=> import('src/pages/dashboard/appointments'))
const TipoCitas = lazy(()=> import('src/pages/dashboard/appointmentType'))
const CrearTipoCitas = lazy(()=> import('src/pages/dashboard/appointmentTypeCreate'))
const CrearPaciente = lazy(()=> import('src/pages/dashboard/patientCreate'))
const EditarPaciente = lazy(()=> import('src/pages/dashboard/patientEdit'))
const EditarCita = lazy(()=> import('src/pages/dashboard/appointmentEdit'))
const ExpedientePaciente = lazy(()=> import('src/pages/dashboard/patientExpediente'))

// FEL
const FelList = lazy(()=> import('src/pages/dashboard/felList'))
const FelCreate = lazy(()=> import('src/pages/dashboard/felCreate'))

// Autogestión
const MesasAutoservicioList = lazy(() => import('src/pages/dashboard/autogestion/mesasListPage'));
const MesasAutoservicioCreate = lazy(() => import('src/pages/dashboard/autogestion/mesasCreatePage'));
export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet /> 
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'Productos',
        children: [
          { element: <Products />, index: true },
          { path: 'new', element: < ProductsCreateView/> },
          { path: 'combos/new', element: <CombosCreateView /> },
          { path: 'combos/:id/edit', element: <CombosEditView /> },
          { path: 'edit/:id', element: <ProductEditView/>}
        ],
      },
      {
        path: 'ConfiguracionFEL',
        children: [
          { element: <ConfiguracionFel />, index: true },
          { path: 'new', element: < ConfiguracionFelCreate/> },
        ],
      },
      {
        path: 'historico',
        children: [
          { element: <History />, index: true },
        ],
      },
      {
        path: 'EstadisticasVentas',
        children: [
          { element: <DashboardVentas />, index: true },
        ],
      },
      {
        path: 'Comparativos',
        children: [
          { element: <DashboardComparisons />, index: true },
        ],
      },
      {
        path: 'cocina',
        children: [
          { element: <Kitchen />, index: true },
        ],
      },
      {
        path: 'clientes',
        children: [
          { element: <Clients />, index: true },
        ],
      },
      {
        path: 'traslados',
        children: [
          { element: <Traslados />, index: true },
          { path: 'new', element: <TrasladosCreatePage /> },
          { path: ':id/edit', element: <TrasladosEditPage /> },
        ],
      },
      {
        path: 'compras',
        children: [
          { element: <Compras />, index: true },
          { path: 'new', element: <ComprasCreatePage /> },
        ],
      },
      {
        path: 'proveedores',
        children: [
          { element: <Proveedores />, index: true },
        ],
      },
      {
        path: 'publicas',
        children: [
          { element: <UserAccountPage />, index: true },
        ],
      },
      {
        path: 'Cajas',
        children: [
          { element: <CashBox />, index: true },
        ],
      },
      {
        path: 'Cajeros',
        children: [
          { element: <Cashiers />, index: true },
          { path: 'new', element: < CashiersCreateView/> },
        ],
      },
      {
        path: 'Categorias',
        children: [
          { element: <Categories />, index: true },
          { path: 'new', element: <CategoriesCreateView/> },
        ],
      },
      {
        path: 'IngredientesPorProducto',
        children: [
          { element: <PronosticoInventario />, index: true },
        ],
      },
      {
        path: 'PronosticoInventario',
        children: [
          { element: <PronosticoProductos />, index: true },
        ],
      },
      {
        path: 'ReporteVentas',
        children: [
          { element: <ReporteVentas />, index: true },
        ],
      },
      {
        path: 'atributos',
        children: [
          { element: <Atributos/>, index: true},
          { path: 'new', element: <AtributosCreateView/> },
        ]
      },
      {
        path: 'impresoras',
        children: [
          { element: <Impresoras/>, index: true},
          { path: 'new', element: <ImpresorasCreateView/> },
        ]
      },
      {
        path: 'pacientes',
        children: [
          { element: <Pacientes/>, index:true  },
          { path: 'new', element: <CrearPaciente/>},
          { path: 'edit/:id', element: <EditarPaciente/>},
          { path: 'expedient/:id', element: <ExpedientePaciente/>}
        ]
      },
      {
        path: 'citas',
        children: [
          { element: <Citas/>, index:true  },
          { path: 'edit/:id', element: <EditarCita/>}

        ]
      },
      {
        path: 'tipoCitas',
        children: [
          { element: <TipoCitas/>, index:true  },
          { path: 'new', element: <CrearTipoCitas/>}
        ]
      },
      {
        path: 'fel',
        children: [
          { element: <FelList/>, index:true  },
          { path: 'new', element: <FelCreate/>}
        ]
      },
      {
        path: 'autogestion/mesas',
        children: [
          { element: <MesasAutoservicioList />, index: true },
          { path: 'new', element: <MesasAutoservicioCreate /> },
        ]
      }
    ],
  },
];
